import { useInviteModal } from "@components/ModalContext/InviteModalContext";
import { FC, useState } from "react";
import { AddTokensModal } from "../../addTokensModal/AddTokensModal";
import styles from "./user-details.module.scss";

type Props = {
  userDetails: any;
  updateUserDetails: any;
};

const UserDetails: FC<Props> = ({ userDetails, updateUserDetails }) => {
  const { openModal } = useInviteModal();
  const [addTokensModal, setAddTokensModal] = useState(false);

  function closeModal({ fetchUserDetails = false }) {
    setAddTokensModal(false);
    if (fetchUserDetails) {
      updateUserDetails();
    }
  }

  return (
    <div className={styles.userDetails}>
      <div className={styles.userDetailsContent}>
        <div className={styles.userDetailsCard}>
          <h2 className={styles.userDetailsCardTitle}>Profile details</h2>
          <div className={styles.userDetailsCardItem}>
            <div>Full name:</div>
            <div>{userDetails?.name}</div>
          </div>
          <div className={styles.userDetailsCardItem}>
            <div>Email Address:</div>
            <div>{userDetails?.email}</div>
          </div>
          <div className={styles.userDetailsCardItem}>
            <div>Country:</div>
            <div>{userDetails?.country}</div>
          </div>
          <div className={styles.userDetailsCardItem}>
            <div>Entity Type:</div>
            <div>{userDetails?.["entity type"]}</div>
          </div>
        </div>
        {/*<div className={styles.userDetailsCard}>*/}
        {/*  <h2 className={styles.userDetailsCardTitle}>Plan details</h2>*/}
        {/*  <p className={styles.userDetailsCardSubtitle}>*/}
        {/*    “{userDetails?.plan}” workspace*/}
        {/*  </p>*/}
        {/*  <p className={styles.userDetailsCardText}>*/}
        {/*    Plan renews on {userDetails?.renew_date}*/}
        {/*  </p>*/}
        {/*  <div className={styles.userDetailsCardBorder} />*/}
        {/*</div>*/}
        {userDetails.plan === "Enterprise" && (
          <div className={styles.userDetailsCard}>
            <h2 className={styles.userDetailsCardTitle}>Users (seats)</h2>
            <p className={styles.userDetailsCardSubtitle}>
              {userDetails?.remaining_subaccounts} users remaining
            </p>
            <p className={styles.userDetailsCardText}>
              {userDetails?.subaccounts || 0} users in your plan
            </p>
            <div className={styles.userDetailsCardBorder} />
            <p
              className={styles.userDetailsCardButton}
              onClick={() => openModal()}
            >
              Add users
            </p>
          </div>
        )}
        <div className={styles.userDetailsCard}>
          <h2 className={styles.userDetailsCardTitle}>Credits</h2>

          <div className={styles.userDetailsCardRow}>
            <p className={styles.userDetailsCardSubtitle}>
              Credits used:{" "}
              <strong>
                {Math.floor(Number(userDetails.credits_used)).toLocaleString(
                  "en-US",
                )}
              </strong>
            </p>
            <span className={styles.tokenAmount}>
              {userDetails.tokens_used} tokens
            </span>
          </div>

          <div className={styles.userDetailsCardRow}>
            <p className={styles.userDetailsCardSubtitle}>
              Credits purchased:{" "}
              <strong>
                {Number(userDetails.credits_purchased).toLocaleString("en-US")}
              </strong>
            </p>
            <span className={styles.tokenAmount}>
              {Number(userDetails.tokens_purchased).toLocaleString()} tokens
            </span>
          </div>
          <div className={styles.userDetailsCardBorder} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "14px 0 -15px 0",
              gap: "12px",
            }}
          >
            <p
              className={styles.userDetailsCardButton}
              onClick={() => setAddTokensModal(true)}
              style={{
                margin: "0",
                color: userDetails?.plan === "Basic" ? "#80db9f" : "",
              }}
            >
              Increase Credits Limit
            </p>
          </div>
        </div>
      </div>
      <AddTokensModal
        isOpen={addTokensModal}
        closeModal={closeModal}
        user={userDetails}
      />
    </div>
  );
};

export default UserDetails;
